import { Component, Input, OnInit } from '@angular/core';
import { STUDY_KPI_TOOLTIP_CONTENTS_MAP } from '@catalogues';
import { KpiKeys, KpiNames, MilestoneName } from '@models';

@Component({
  selector: 'kpi-tooltip',
  templateUrl: './kpi-tooltip.component.html',
  styleUrl: './kpi-tooltip.component.scss'
})
export class KpiTooltipComponent implements OnInit {
  @Input() kpiName!: KpiNames | string;
  @Input() kpiKey!: KpiKeys;
  @Input() keyMilestones?: MilestoneName[];

  tooltipContents!: { description: string; keyMilestones?: MilestoneName[]; thresholds?: string[] };

  ngOnInit() {
    this.tooltipContents = {
      ...(STUDY_KPI_TOOLTIP_CONTENTS_MAP[this.kpiKey] || {
        description: 'No description available'
      })
    };
    if (this.kpiKey === 'key_milestones_on_track_to_baseline' && this.keyMilestones !== undefined) {
      this.tooltipContents.keyMilestones = this.keyMilestones;
    }
  }
}
